// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgw_a bic_vt bic_ea bic_a","MenuItem__Btn":"bgw_b bic_z","MenuItem__subtitle":"bgw_c"};